module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/arrow_up-17a966fcb16cd17f03efeafcee285dc3.svg";